'use client'

import React, { useMemo } from 'react'
import dynamic from 'next/dynamic'

import { useTranslations } from 'next-intl'

import { RecentSearchListItem, useRecentSearch } from '@/src/hooks/srp/recentSearch'
import { isServer } from '@/src/utils/browser'

// Dynamic imports for code splitting
const DesktopRecentSearchList = dynamic(
    () => import(/* webpackChunkName: "desktop-recent-search" */ './recentSearchList'),
    { ssr: true }
)

const MobileRecentSearchList = dynamic(
    () => import(/* webpackChunkName: "mobile-recent-search" */ './mobileRecentSearchList'),
    { ssr: true }
)

interface RecentSearchListWrapperProps {
    serverRecentSearches: RecentSearchListItem[]
    isMobile: boolean
}

const RecentSearchListWrapper: React.FC<RecentSearchListWrapperProps> = ({ serverRecentSearches, isMobile }) => {
    const { getRecentSearchList } = useRecentSearch()
    const t = useTranslations('homePage.headings')

    const recentSearches = useMemo(
        () => (isServer() ? serverRecentSearches : getRecentSearchList()),
        [serverRecentSearches, getRecentSearchList]
    )

    if (!recentSearches || recentSearches.length === 0) {
        return null
    }

    const heading = t('recentSearches')

    return isMobile ? (
        <MobileRecentSearchList flightsSearchList={recentSearches} heading={heading} />
    ) : (
        <DesktopRecentSearchList flightsSearchList={recentSearches} heading={heading} />
    )
}

export { RecentSearchListWrapper }
export default RecentSearchListWrapper
